import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';
interface HttpListComponentProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  onBlur?: () => void;
  error?: boolean;
}

const http = [
  {
    id: '1',
    value: 'GET',
  },
  {
    id: '2',
    value: 'POST',
  },
  {
    id: '3',
    value: 'PUT',
  },
  {
    id: '4',
    value: 'DELETE',
  },
];

const HttpListComponent = ({
  disabled,
  onChange,
  onBlur = () => {
    return;
  },
  value,
  error,
  required,
}: HttpListComponentProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="http-label">
        {required ? 'Metodo http *' : 'Metodo http'}
      </InputLabel>
      <PmiSelect
        labelId="http-label"
        id="httpMethod"
        name="httpMethod"
        value={value}
        label={required ? 'Metodo http *' : 'Metodo http'}
        onChange={onChange}
        disabled={disabled}
        error={error}
        onBlur={onBlur}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {http.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.value}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

HttpListComponent.displayName = 'Http item component';

const HttpList = memo(HttpListComponent);

export default HttpList as typeof HttpListComponent;
